import { CSSProperties } from 'react';
import styled from 'styled-components';

export const Container = styled.div`
	max-width: min(1480px, calc(100vw - 32px));
	margin: 0 auto;
	padding: clamp(1rem, 3vw, 2rem) clamp(1rem, 3vw, 2.5rem);
	padding-bottom: clamp(2.5rem, 6vw, 4rem);

	.verify {
		background: linear-gradient(
			135deg,
			var(--action-accent-surface) 0%,
			var(--text-secondary) 100%
		);
		color: var(--text-on-inverse);
		width: auto;
		min-width: 10.4em;
		height: 3.25rem;
		padding: 0 1.75rem;
		border: none;
		margin-left: 0;
		margin-top: 0.25rem;
		border-radius: 999px;
		font-weight: 600;
		letter-spacing: 0.02em;
		box-shadow: var(--elevation-accent);
		transition: transform 0.2s ease, box-shadow 0.2s ease,
			filter 0.2s ease;
	}

	.verify:hover {
		transform: translateY(-2px);
		box-shadow: var(--elevation-accent);
		filter: brightness(1.05);
	}

	.verify:active {
		transform: translateY(0);
	}

	.hide {
		display: none;
	}
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;
`;

export const Title = styled.h4`
	font-weight: 600;
	font-size: clamp(1.5rem, 2.4vw, 1.875rem);
	line-height: 1.2;
	letter-spacing: -0.03em;
	color: var(--text-primary);
	margin: clamp(0.75rem, 2vw, 1.5rem) 0 1.25rem;
`;

export const SubTitle = styled.span`
	font-weight: 600;
	font-size: clamp(1rem, 1.8vw, 1.125rem);
	line-height: 1.35;
	letter-spacing: -0.02em;
	color: var(--text-secondary);
	display: block;
	margin-bottom: 1rem;
	margin-top: 0.25rem;
	padding-bottom: 0.65rem;
	border-bottom: 1px solid var(--border-default);
`;

export const Form = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
`;

export const FormField = styled.div`
	width: 100%;
	display: flex;
	margin: 10px;
`;

export const Text = styled.span`
	max-width: 140px;
	min-width: 140px;
	font-size: 16px;
	line-height: 24px;
	text-align: right;
	margin: 0 20px;
`;

export const Input = styled.input`
	display: none;
`;

export const InputStyled: CSSProperties = {
	maxWidth: '100%',
	width: '100%',
	minWidth: 0,
	marginBottom: '4px',
};

export const InputFormStyled: CSSProperties = {
	maxWidth: '360px',
	minWidth: '140px',
};

export const Load = styled.div`
	background: var(--border-accent);
	border-radius: 14px;
	max-width: 20%;
	margin-top: 15px;
	margin-bottom: 15px;
	padding-top: 10px;
	padding-bottom: 10px;
	display: flex;
	div {
		margin-left: 15px;
		img {
			width: 30px;
			height: 30px;
		}
	}
	span {
		font-family: var(--font-body);
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 16px;
		display: flex;
		align-items: center;
		text-align: center;
		letter-spacing: 1.25px;
		text-transform: capitalize;
		color: var(--text-primary);
	}
`;

export const LoadFile = styled.span`
	display: flex;
`;

export const AddNewFile = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 33px;
	margin-left: 15%;
	cursor: pointer;
`;

export const ContainerForm = styled.div`
	width: 100%;
	margin-bottom: 0.5rem;
`;

export const ContainerTextArea = styled.div`
	display: flex;
	align-items: stretch;
	flex-direction: column;
	width: 100%;
	margin-bottom: 1.25rem;
	padding: 1rem 1.15rem 1.15rem;
	border-radius: 18px;
	background: linear-gradient(
		160deg,
		var(--surface-raised) 0%,
		var(--surface-canvas) 100%
	);
	box-shadow: 0 0 0 1px var(--border-default), var(--elevation-3);

	label {
		margin-bottom: 0.65rem;
		font-weight: 500;
		font-size: 0.875rem;
		color: var(--text-primary);
	}

	textarea {
		border-radius: 14px !important;
		border: 1px solid var(--border-default) !important;
		padding: 1rem 1.1rem !important;
		font-size: 0.9375rem !important;
		line-height: 1.55 !important;
		resize: vertical;
		min-height: 0 !important;
		transition: border-color 0.2s ease, box-shadow 0.2s ease;
		background: var(--surface-raised) !important;
	}

	textarea:focus {
		outline: none;
		border-color: var(--action-accent-surface) !important;
		box-shadow: 0 0 0 3px var(--info-surface);
	}
`;
